angular.module('lf.desktop')

.directive('wrapNavAccount', function ($compile, $rootScope, $timeout, preloadData, i18n) {
  return function (scope, el, attrs) {
    var externalPopovers = attrs.wrapNavAccount === 'external';
    var isHardgoods = preloadData.siteProductType === 'hardgoods';
    var isLFC = preloadData.client.isLFC;
    if(!isLFC) {
    	var hardgoodsSiteBaseUrl = isHardgoods ? preloadData.siteBaseUrl : preloadData.sisterSite.siteBaseUrl;
    }
    var softgoodsSiteBaseUrl = isHardgoods ? preloadData.sisterSite.siteBaseUrl : preloadData.siteBaseUrl;
    var isGuest = preloadData.user.status === 'GUEST';
    
    var hardgoodsCart = '';
    if(!isLFC) {
        hardgoodsCart = (preloadData.checkoutFlow || !preloadData.shop.hardgoodsCart) ? '' : [
	      // Mini Cart - Hardgoods
	      '<li class="nav-account__mini-cart-hardgoods-list-item">',
	        '<a href="' + hardgoodsSiteBaseUrl + '/checkout/" class="nav-account__mini-cart-hardgoods-link" bind-popover="mini-cart-hardgoods"><i class="fa fa-shopping-cart"></i>' + i18n.header.hardgoodsCart + ' (<span ng-bind="getHardgoodsCartItemsCount()">0</span>)</a>',
	      '</li>'].join('');
    }
    
    var softgoodsCart = (preloadData.checkoutFlow || !preloadData.shop.softgoodsCart) ? '' : [
      '<li class="nav-account__mini-cart-softgoods-list-item">',
      '<a href="' + softgoodsSiteBaseUrl + '/checkout/" class="nav-account__mini-cart-softgoods-link" bind-popover="mini-cart-softgoods"><i class="fa fa-shopping-cart"></i>' + i18n.header.softgoodsCart + ' (<span ng-bind="getSoftgoodsCartItemsCount()">0</span>)</a>',
      '</li>'].join('');
    
    var wishlist = (preloadData.checkoutFlow || isGuest) ? '' : [
        '<li class="nav-account__my-wishlist-list-item">',
          '<a href="' + preloadData.siteBaseUrl + '/profile/wishlist.jsp" class="nav-account__my-account-link" bind-popover="mini-wishlist"><i class="fa fa-heart-o"></i>' + i18n.header.wishlist + ' (<span ng-bind="getWishlistItemsCount()">0</span>)</a>',
        '</li>'].join('');
    
    var $navAccount = $('#navAccount');
    $navAccount
      .empty()
      .html([

        // My Account
        '<li class="nav-account__my-account-list-item">',
          '<a href="' + preloadData.siteBaseUrl + '/profile/" class="nav-account__my-account-link" bind-popover="my-account" id="headerLogin">' + i18n.header.myAccount + '</a>',
        '</li>',
        
        // My Wishlist
        wishlist,
        hardgoodsCart,
        softgoodsCart
      
      ].join(''));
    
      var compile = function() {
        $compile($navAccount)($rootScope);
      }
      
      if (!externalPopovers) {
        compile();
        return;
      }
      
      // Event doesn't identify the source element. . . would like to hook into the specific ng-include here
      scope.$on('$includeContentLoaded', function(e) {
        compile();
      });
  }
});
